export default "__VITE_PUBLIC_ASSET__7fd4ef75__"